import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterModule]
})
export class AppComponent {

  private readonly ngSelectConfig = inject(NgSelectConfig);

  constructor() {
    this.ngSelectConfig.notFoundText = 'No se encontraron resultados';
    this.ngSelectConfig.bindValue = 'value';
    this.ngSelectConfig.placeholder = 'Selecciona una opción';
  }
}
